;<template>
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00031 10.8182C8.65031 10.8182 10.8185 8.65001 10.8185 6.00001C10.8185 3.35001 8.65031 1.18182 6.00031 1.18182C3.35031 1.18182 1.18213 3.35001 1.18213 6.00001C1.18213 8.65001 3.35031 10.8182 6.00031 10.8182Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.51855 4.41L8.16855 3.88L7.63855 6.48182C7.59037 6.77091 7.44583 7.01182 7.2531 7.20455C7.06037 7.39728 6.81946 7.54182 6.53037 7.59001L3.88037 8.12L4.41037 5.51819C4.45855 5.2291 4.55492 4.98819 4.79583 4.79546C4.98855 4.55455 5.22946 4.45819 5.51855 4.41Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
